import type { LighthouseAudit } from '@/app/PageSpeed/api/types/analysisApiTypes';

type Props = { audit: LighthouseAudit };

const ErrorAuditRenderer = ({ audit }: Props) => {
  return (
    <div className="fs--1">
      <h6>{audit.title}</h6>
      <p>Error: {audit.errorMessage}</p>
    </div>
  );
};

export default ErrorAuditRenderer;
